import ApiService from "@/common/api/api.service";
import JwtService from "@/common/utils/jwt";

const AutenticacaoService = {
  logar(form) {
    return ApiService.post(
      `autenticacao/autenticar`,
      {
        ...form,
        // Se este navegador ja passou pelo segundo fator, o backend dispensa o codigo.
        tokenDispositivo: JwtService.buscarTokenDispositivo(),
      },
      { noToast: true }
    );
  },
  validarMfa(tokenDesafio, codigo, lembrarDispositivo) {
    return ApiService.post(
      `autenticacao/validar-mfa`,
      { tokenDesafio, codigo, lembrarDispositivo },
      { noToast: true }
    );
  },
  reenviarMfa(tokenDesafio) {
    return ApiService.post(
      `autenticacao/reenviar-mfa`,
      { tokenDesafio },
      { noToast: true }
    );
  },
  validarToken() {
    return ApiService.get(`autenticacao/token-valido`);
  },
  async invalidarToken() {
    let ret = await ApiService.put(`autenticacao/invalidar-token`, {}, { noToast: true });
    return ret
  },
};

export default AutenticacaoService;
